module.exports = __webpack_public_path__ + "mp.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mp.svg
// module id = 955
// module chunks = 0